import { Modal, ModalBody, ModalContent } from '@ds';
import { MdOutlineFactCheck } from 'react-icons/md';
import { BulkAssignmentOperation, BulkEmployeeData, CaseUserGroupNames } from '@/api/apis/case';
import { getFullName } from '@/utils/helpers';

type BulkAssignmentInProgressModalProps = {
  isOpen: boolean;
  processedCount: number;
  casesTotal: number;
  operations: BulkAssignmentOperation[];
  relatedEmployees: BulkEmployeeData[];
};

export const BulkAssignmentInProgressModal = ({
  isOpen,
  processedCount,
  casesTotal,
  operations,
  relatedEmployees,
}: BulkAssignmentInProgressModalProps) => {
  const userGroup = operations[0]?.group;
  const userToDetach = relatedEmployees.find((e) => e.employeeId === operations[0]?.detachedEmployeeId);
  const userToAssign = relatedEmployees.find((e) => e.employeeId === operations[0]?.assigningEmployeeId);

  return (
    <Modal
      isOpen={isOpen}
      backdrop="blur"
      isDismissable={false}
      hideCloseButton
      portalContainer={document.querySelector('[data-main-content]') as HTMLElement}
      classNames={{
        base: 'z-30',
        wrapper: 'z-30',
        backdrop: 'z-30',
      }}
    >
      <ModalContent className="max-w-[400px]">
        <ModalBody className="p-6">
          <div className="flex flex-col items-center gap-7">
            <div className="bg-base-60 rounded-[60px] p-4 w-[90px] h-[90px] flex items-center justify-center">
              <MdOutlineFactCheck size={50} className="text-base-20" />
            </div>
            <div className="flex flex-col items-center gap-5">
              <div className="flex flex-col items-center gap-4">
                <h2 className="text-hl text-base-20 font-secondary text-center">Bulk Cases Processing</h2>
                <div className="flex flex-col items-start gap-1">
                  {casesTotal > 0 && (
                    <p className="text-m-m text-base-10 text-center w-full">
                      {processedCount} of {casesTotal}
                    </p>
                  )}
                </div>
                <div className="flex flex-col items-start gap-1 text-base-10 text-center">
                  {userGroup && <p className="text-m-sb w-full">{CaseUserGroupNames[userGroup]}</p>}
                  {userToDetach && (
                    <p className="text-m-m w-full">
                      Detach:{' '}
                      <span className="text-m-sb">{getFullName(userToDetach.firstName, userToDetach.lastName)}</span>
                    </p>
                  )}
                  {userToAssign && (
                    <p className="text-m-m w-full">
                      Add:{' '}
                      <span className="text-m-sb">{getFullName(userToAssign.firstName, userToAssign.lastName)}</span>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
